import { getCountryCodeAndNameFromValue } from '@services/new/common/getLeadMeta';
import { isValidPhoneNumber } from '@utils/validation.utils';
import * as yup from 'yup';

export type InputNames =
  | 'firstName'
  | 'lastName'
  | 'companyName'
  | 'email'
  | 'contact'
  | 'countryCode'
  | 'city'
  | 'nationality'
  | 'language'
  | 'interestedArea'
  | 'interestedProject'
  | 'retailCategory'
  | 'goldenVisa'
  | 'consent'
  | 'otherPropertyUpdates'
  | 'aldarUpdates';
type ConsentTypes = 'aldarConsent' | 'lsqConsent';
export type FormTypes = 'PROPERTY_FORM' | 'LSQ_PROPERTY_FORM' | 'RESALE_FORM' | 'BROCHURE_FORM' | 'LSQ_BROCHURE_FORM' | 'COMMUNITY_FORM' | 'LSQ_COMMUNITY_FORM';
// 'CONTACT_FORM' |

export const BOOLEAN_INPUTS = [
  'consent',
  'goldenVisa',
  'otherPropertyUpdates',
  'aldarUpdates',
];
export const parseDataForSubmit = (data: Record<InputNames, string>) => {
  const booleanSubObj = Object.fromEntries(
    Object.entries(data).map(([key, value]) => {
      if (BOOLEAN_INPUTS.includes(key)) {
        return [key, Boolean(value)];
      }
      return [key, value];
    })
  );
  const { code, name } = getCountryCodeAndNameFromValue(data.countryCode!!);
  return { ...booleanSubObj, countryCode: code, country: name };
};

export type VisibilityProps = {
  name: InputNames | ConsentTypes;
  formType: FormTypes;
};
//enable aldar consent for normal consent enable
export const getVisibilityProps = ({ name, formType }: VisibilityProps) => {
  // const contactFormInputs = [
  //   'firstName',
  //   'lastName',
  //   'email',
  //   'contact',
  //   'countryCode',
  //   'city',
  //   'nationality',
  //   'language',
  //   'interestedArea',
  //   'interestedProject',
  //   'goldenVisa',
  //   'consent',
  // ];
  const propertyFormInputs = [
    'firstName',
    'lastName',
    'email',
    'contact',
    'countryCode',
    'city',
    'nationality',
    'language',
    'goldenVisa',
    'consent',
    'aldarConsent',
  ];
  const lsqPropertyFormInputs = [
    'firstName',
    'lastName',
    'email',
    'contact',
    'countryCode',
    'city',
    'nationality',
    'language',
    'consent',
    'otherPropertyUpdates',
    'aldarUpdates',
    'lsqConsent',
  ];
  const resaleFormInputs = [
    'firstName',
    'lastName',
    'companyName',
    'mobile',
    'countryCode',
    'email',
    'retailCategory',
    'consent',
    'aldarConsent',
  ];
  switch (formType) {
    // case 'CONTACT_FORM':
    //   return !contactFormInputs.includes(name);
    case 'PROPERTY_FORM':
    case 'COMMUNITY_FORM':
      return !propertyFormInputs.includes(name);
    case 'LSQ_PROPERTY_FORM':
    case 'LSQ_COMMUNITY_FORM':
      return !lsqPropertyFormInputs.includes(name);
    case 'RESALE_FORM':
      return !resaleFormInputs.includes(name);
    default:
      return false;
  }
};

export function getValidationSchema(formType: FormTypes) {
  switch (formType) {
    // case 'CONTACT_FORM':
    //   return yup
    //     .object({
    //       firstName: yup
    //         .string()
    //         .required('First name is required')
    //         .max(35, 'First name is too long')
    //         .matches(
    //           /^[A-Za-z\s]+$/,
    //           'First name is invalid'
    //         ),
    //       lastName: yup
    //         .string()
    //         .required('Last name is required')
    //         .max(35, 'Last name is too long')
    //         .matches(
    //           /^[A-Za-z\s]+$/,
    //           'Last name is invalid'
    //         ),
    //       countryCode: yup.string().required('Country code is required'),
    //       contact: yup
    //         .string()
    //         .required('Phone number is required')
    //         .test(
    //           'Phone Number Validity Check',
    //           'Not a valid phone number',
    //           function (number) {
    //             const {code} = getCountryCodeAndNameFromValue(
    //               this.parent.countryCode
    //             );
    //             return isValidPhoneNumber(number, code);
    //           }
    //         ),
    //       email: yup
    //         .string()
    //         .required('Email is required')
    //         .email('Invalid email format'),
    //       city: yup
    //         .string()
    //         .ensure()
    //         .when('country', (country, schema) => {
    //           return country[0] === 'United Arab Emirates'
    //             ? schema.required('City is required')
    //             : schema;
    //         }),
    //       interestedArea: yup.string().required('Interested in is required'),
    //       interestedProject: yup
    //         .string()
    //         .required('Interested project is required'),
    //       nationality: yup.string().required('Nationality is required'),
    //       language: yup.string().required('Language is required'),
    //       consent: yup
    //         .string()
    //         .required(
    //           'Consent to Privacy Policy & Terms and Conditions to continue'
    //         ),
    //     })
    //     .required();

    case 'PROPERTY_FORM':
    case 'COMMUNITY_FORM':
      return yup
        .object({
          firstName: yup
            .string()
            .trim()
            .max(35, 'First name is too long')
            .matches(/^[A-Za-z]+(?:\s[A-Za-z]+)*$/, 'First name is invalid')
            .required('First name is required'),
          lastName: yup
            .string()
            .trim()
            .max(35, 'Last name is too long')
            .matches(/^[A-Za-z]+(?:\s[A-Za-z]+)*$/, 'Last name is invalid')
            .required('Last name is required'),
          countryCode: yup.string().required('Country code is required'),
          contact: yup
            .string()
            .test(
              'Phone Number Validity Check',
              'Not a valid phone number',
              function (number) {
                const { code } = getCountryCodeAndNameFromValue(
                  this.parent.countryCode
                );
                return isValidPhoneNumber(number as string, code);
              }
            )
            .required('Phone number is required'),
          email: yup
            .string()
            .email('Invalid email format')
            .required('Email is required'),
          nationality: yup.string().required('Nationality is required'),
          language: yup.string().required('Language is required'),
          consent: yup
            .string()
            .required(
              'Consent to Privacy Policy & Terms and Conditions to continue'
            ),
        })
        .required();
    case 'LSQ_PROPERTY_FORM':
    case 'LSQ_COMMUNITY_FORM':
      return yup
        .object({
          firstName: yup
            .string()
            .trim()
            .max(35, 'First name is too long')
            .matches(/^[A-Za-z]+(?:\s[A-Za-z]+)*$/, 'First name is invalid')
            .required('First name is required'),
          lastName: yup
            .string()
            .trim()
            .max(35, 'Last name is too long')
            .matches(/^[A-Za-z]+(?:\s[A-Za-z]+)*$/, 'Last name is invalid')
            .required('Last name is required'),
          countryCode: yup.string().required('Country code is required'),
          contact: yup
            .string()
            .test(
              'Phone Number Validity Check',
              'Not a valid phone number',
              function (number) {
                const { code } = getCountryCodeAndNameFromValue(
                  this.parent.countryCode
                );
                return isValidPhoneNumber(number as string, code);
              }
            )
            .required('Phone number is required'),
          email: yup
            .string()
            .required('Email is required')
            .email('Invalid email format'),
          nationality: yup.string().required('Nationality is required'),
          language: yup.string().required('Language is required'),
          consent: yup
            .string()
            .required(
              'Consent to Privacy Policy & Terms and Conditions to continue'
            ),
        })
        .required();
    case 'RESALE_FORM':
      return yup
        .object({
          firstName: yup
            .string()
            .trim()
            .max(35, 'First name is too long')
            .matches(/^[A-Za-z]+(?:\s[A-Za-z]+)*$/, 'First name is invalid')
            .required('First name is required'),
          lastName: yup
            .string()
            .trim()
            .max(35, 'Last name is too long')
            .matches(/^[A-Za-z]+(?:\s[A-Za-z]+)*$/, 'Last name is invalid')
            .required('Last name is required'),
          companyName: yup
            .string()
            .max(35, 'Company name is too long')
            .matches(/^[A-Za-z\s]+$/, 'Company name is invalid')
            .required('Company name is required'),
          countryCode: yup.string().required('Country code is required'),
          contact: yup.string().required('Phone number is required'),
          retailCategory: yup.string().required('Retail Category is required'),
          email: yup
            .string()
            .email('Invalid email format')
            .required('Email is required'),
          consent: yup
            .string()
            .required(
              'Consent to Privacy Policy & Terms and Conditions to continue'
            ),
        })
        .required();
  }
}

export function parseValidationErrors(
  validationError: any
): Record<InputNames, string> {
  let errorMessages: Record<string, string> = {};
  validationError.inner.forEach((error: yup.ValidationError) => {
    if (error.path) {
      errorMessages[error.path] = error.message;
    }
  });
  return errorMessages;
}
